import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_HOMEPAGE = "SHOP:UPSERT_HOMEPAGE";

export const upsertHomepageAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string,
  image?: File
) => ({
  type: UPSERT_HOMEPAGE as typeof UPSERT_HOMEPAGE,
  organization,
  data,
  id,
  image,
});

export type UpsertHomepageAction = ReturnType<typeof upsertHomepageAction>;
